import React, { FC, JSX, useRef, useState } from "react";
import { areEqualProps } from "@helperFunctions/checkDidPropChange";
import { PillButton } from "../pillButton/PillButton";
import { TMenuOption } from "../../../types/contextMenu/TMenuOption";
import ContextMenuOptions from "@components/contextMenu";

export interface Option {
  label: string;
  disabled: boolean;
  children: TMenuOption[];
}

interface IProps {
  buttonText: string;
  options: Option[];
  startIcon: JSX.Element;
  endIcon: JSX.Element;
  width?: number;
  height?: number;
  disabled?: boolean;
  shouldCloseOnSelect?: boolean;
}

const AddFormCtrl: FC<IProps> = ({
  buttonText,
  options,
  startIcon,
  endIcon,
  width,
  height,
  disabled = false,
  shouldCloseOnSelect = false,
}): JSX.Element => {
  const pillButtonRef = useRef<HTMLButtonElement | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const handleAddFormClick = (): void => {
    setAnchorEl(pillButtonRef.current);
  };
  const hideParentHandler = (): void => {
    setAnchorEl(null);
  };
  return (
    <>
      <ContextMenuOptions
        parentRef={anchorEl}
        openFromElement={anchorEl}
        hideParent={hideParentHandler}
        options={options}
        shouldCloseOnSelect={shouldCloseOnSelect}
      />
      <PillButton
        refEl={pillButtonRef}
        buttonText={buttonText}
        height={height ?? 36}
        pillButtonClickHandler={handleAddFormClick}
        startIcon={startIcon}
        endIcon={endIcon}
        width={width ?? 110}
        disabled={disabled}
      />
    </>
  );
};

const AddFormControl = React.memo(AddFormCtrl, areEqualProps);
export default AddFormControl;
